'use strict';

import GroupsList from './groups.list.ctrl';

export default angular
  .module('main.groups', [
    GroupsList
  ])
  .name;
